<template lang="html">
  <div class="icon-tiles">
    <div class="container">
      <div class="icon-tiles__wrapper">
        <IconTile
          v-for="item in children"
          :key="item.id"
          :item="item"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { sortBy } from 'lodash'
import editable from '@i22/frontend-cms-utils/mixins/editable'
import IconTile from 'beisheim/components/elements/icon-tile'

export default {
  components: {
    IconTile
  },
  mixins: [ editable ],
  computed: {
    children () {
      return sortBy(this.resource.children, 'sort_key')
    }
  }
}
</script>

<style lang="scss">
@import '~beisheim/scss/scale';
@import '~beisheim/scss/breakpoints';
@import '~beisheim/scss/px-to-rem';

.icon-tiles {
  background-position: center top;
  position: relative;
  overflow: hidden;
  margin-top: scale(10);
  margin-bottom: scale(10);

  &__wrapper {
    display: grid;
    grid-template-columns: 100%;
    grid-template-rows: auto;
    grid-row-gap: 40px;
    grid-column-gap: 4%;
    margin-bottom: 40px;

    @include from(4) {
      grid-template-columns: 48% 48%;
    }
  }
}
</style>
